import React from 'react';
import { injectStripe } from 'react-stripe-elements';

import PatientStripeProvider from '../../hoc/PatientStripeProvider';
import Invoices from './Invoices';

const InvoicesWithStripe = injectStripe<{}>(Invoices);

const InvoicesWithStripeProvider = () => (
  <PatientStripeProvider>
    <InvoicesWithStripe />
  </PatientStripeProvider>
);

export default InvoicesWithStripeProvider;
